import { TOC } from "./ebookToc";

export const EBOOKS = [
  {
    slug: "linkedin-ads",
    key: "linkedin",
    vol: "01",
    platform: "LinkedIn Ads",
    title: "LinkedIn Ads, end-to-end.",
    series: "The Paid Social Series",
    price: 49,
    url: "https://thedigitalmarketerr.gumroad.com/l/satjbn",
    accent: "#0A66C2",
    description:
      "The complete operator's manual for running LinkedIn as a pipeline channel — targeting, attribution, and everything between.",
    intro:
      "LinkedIn is the only place where professional identity — title, company, seniority, skill — is declared by the person, verified by their peers, and updated in real time. This volume is written for the people who sit inside Campaign Manager every week: what to build, what to measure, what to ignore, and what to never do twice.",
    audit: "/linkedin-ads-audit",
    samplePages: [3, 13, 21],
  },
  {
    slug: "google-ads",
    key: "google",
    vol: "02",
    platform: "Google Ads",
    title: "Google Ads, end-to-end.",
    series: "The Paid Search Series",
    price: 49,
    url: "https://thedigitalmarketerr.gumroad.com/l/lesrp",
    accent: "#4285F4",
    description:
      "The complete operator's manual for running Google as a pipeline channel — intent capture, Smart Bidding, measurement, and everything between.",
    intro:
      "Google is the only place where the buyer tells you — in their own words, at the exact moment — what problem they are trying to solve. This volume is written for the people who sit inside the Google Ads account every week: what to build, what to measure, what to ignore, and what to never do twice.",
    audit: "/google-ads-audit",
    samplePages: [3, 13, 21],
  },
  {
    slug: "meta-ads",
    key: "meta",
    vol: "03",
    platform: "Meta Ads",
    title: "Meta Ads, end-to-end.",
    series: "The Paid Social Series",
    price: 39,
    url: "https://thedigitalmarketerr.gumroad.com/l/dwdncf",
    accent: "#0064E0",
    description:
      "The complete operator's manual for running Facebook and Instagram as a B2B pipeline channel — audiences, the Pixel and CAPI, attribution, and everything between.",
    intro:
      "Meta is where your buyer spends the hours they are not working — which is exactly why it reaches them when no competitor is in the room. This volume shows how to seed Meta with first-party data and run it from Ads Manager every week: what to build, what to measure, what to ignore, and what to never do twice.",
    audit: "/meta-ads-audit",
    samplePages: [3, 13, 21],
  },
  {
    slug: "bing-ads",
    key: "bing",
    vol: "04",
    platform: "Bing Ads",
    title: "Bing Ads, end-to-end.",
    series: "The Paid Search Series",
    price: 39,
    url: "https://thedigitalmarketerr.gumroad.com/l/rlvlli",
    accent: "#00897B",
    description:
      "The complete operator's manual for running Microsoft Advertising as a B2B pipeline channel — the Google import, LinkedIn Profile Targeting, UET, and everything between.",
    intro:
      "Bing is the search engine of the office — the default on every corporate Windows machine, inside Edge, Outlook and Copilot — which is exactly where your B2B buyer spends the working day. This volume covers what to import, what to measure, what to ignore, and what to never do twice.",
    audit: "/bing-ads-audit",
    samplePages: [3, 14, 21],
  },
].map((b) => ({
  ...b,
  cover: `/ebooks/${b.slug}-cover.webp`,
  samples: b.samplePages.map((p) => ({
    page: p,
    sm: `/ebooks/${b.slug}-p${p}-sm.webp`,
    lg: `/ebooks/${b.slug}-p${p}-lg.webp`,
  })),
  toc: (TOC[b.key] || []).map(([n, title, desc, part]) => ({ n, title, desc, part })),
}));

export const ebookByKey = (key) => EBOOKS.find((b) => b.key === key);
export const ebookBySlug = (slug) => EBOOKS.find((b) => b.slug === slug);
